export default __webpack_public_path__ + "static/media/LINA-BUSD.d1399278.svg";